const fmtH = (n) => (n == null ? '—' : `${Number(n).toLocaleString('cs-CZ', { maximumFractionDigits: 1 })} h`);

/**
 * Jeden volný flek k rozebrání — řádek se jménem směny, časem a tlačítkem.
 *
 * Používá ho detail dne v Mém měsíci (`kompakt`) i celý seznam volných směn,
 * aby nabídka vypadala všude stejně a pravidlo „co nejde vzít, se nezahazuje"
 * platilo na jednom místě: flek bez kvalifikace zůstává vidět ztlumený
 * s důvodem. „Chybí ti Medior" je informace o kariéře, ne chyba.
 */
export default function VolnyFlek({ flek, onVzit, beru = false, isDark, kompakt = false }) {
    const textPrimary = isDark ? '#fff' : 'var(--text-primary)';
    const textMuted = isDark ? 'rgba(255,255,255,0.45)' : 'var(--text-muted)';

    return (
        <div style={{
            display: 'flex', alignItems: 'center', gap: kompakt ? 8 : 10,
            padding: kompakt ? '7px 9px' : '10px 12px',
            borderRadius: kompakt ? 6 : 12,
            background: flek.muzu ? 'rgba(12,192,223,0.08)' : 'transparent',
            border: `1px dashed ${flek.muzu
                ? 'rgba(12,192,223,0.45)'
                : (isDark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)')}`,
            opacity: flek.muzu ? 1 : 0.6,
        }}>
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{
                    fontSize: kompakt ? 12 : 14, fontWeight: 700, color: textPrimary,
                    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                }}>{flek.sablon_nazev || 'Volná směna'}</div>
                <div style={{
                    fontSize: kompakt ? 10.5 : 12, color: textMuted,
                    fontVariantNumeric: 'tabular-nums', marginTop: 1,
                }}>
                    {flek.cas_od}–{flek.cas_do} · {fmtH(flek.hodin)}
                    {flek.kapacita > 1 && ` · zbývá ${flek.zbyva} z ${flek.kapacita}`}
                </div>
                {flek.duvod && (
                    <div style={{ fontSize: kompakt ? 10 : 11.5, color: '#F59E0B', marginTop: 2 }}>{flek.duvod}</div>
                )}
            </div>
            {flek.muzu && (
                <button type="button" onClick={() => onVzit(flek)} disabled={beru} style={{
                    flexShrink: 0, height: kompakt ? 28 : 36, padding: kompakt ? '0 10px' : '0 14px',
                    borderRadius: kompakt ? 7 : 9, border: '1px solid rgba(16,185,129,0.45)',
                    background: 'rgba(16,185,129,0.12)', color: '#10B981',
                    fontSize: kompakt ? 11.5 : 13, fontWeight: 800,
                    cursor: beru ? 'default' : 'pointer', opacity: beru ? 0.6 : 1,
                }}>{beru ? 'Beru…' : 'Převzít'}</button>
            )}
        </div>
    );
}
